import Vue from 'vue';
import Vuex from 'vuex';
// Modulos
import calls from './calls';
import session from './session';
import dropdowns from './dropdowns';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		calls: calls,
		session: session,
		dropdowns: dropdowns
	},
	state: {},
	mutations: {},
	actions: {}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js